import { useState, useRef, useCallback, useEffect } from 'react';

export function useModalAnimation(isOpen: boolean, timeoutMs = 250) {
  const [isClosing, setIsClosing] = useState(false);
  const closingGuard = useRef(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const wasOpenRef = useRef(isOpen);

  const finishClose = useCallback(() => {
    if (closingGuard.current) return;
    closingGuard.current = true;
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsClosing(false);
  }, []);

  useEffect(() => {
    if (isOpen) {
      wasOpenRef.current = true;
      closingGuard.current = false;
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      setIsClosing(false);
    } else if (wasOpenRef.current) {
      wasOpenRef.current = false;
      closingGuard.current = false;
      setIsClosing(true);
      timeoutRef.current = setTimeout(finishClose, timeoutMs);
    }
    return () => { if (timeoutRef.current) clearTimeout(timeoutRef.current); };
  }, [isOpen, finishClose, timeoutMs]);

  return {
    isMounted: isOpen || isClosing,
    isClosing,
    dataState: isClosing ? 'closed' : 'open',
  };
}
